<template>
  <div style="width: 100%; height: 900px" v-if="userEqui == 'pc'">
    <div :id="mapId" class="MapBox"></div>
  </div>
  <div :style="{ width: this.equiWidth, height: '300px' }" v-else>
    <div :id="mapId" class="MapBox"></div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "@/router";
import {mapGetters} from "vuex";
import {MARKER_TYPES, MARKER_BATCH_SIZE} from "@/utils/mapUtil/constants";
import {
  initMap,
  clearMarkers,
  fitView,
  zoomPopupMarker,
  closeMarkersPopup,
  loadLandPolygons,
  addPgAssetPolygons,
  getDimension,
} from "@/utils/mapUtil/funcs.js";
import {
  getBiddingXmxxByPg,
  getBiddingXmxxByPgRedis,
} from "@/api/projectManage";
import OrderInfoWindow from "./orderInfoWindow.vue";
import {offsetLocation} from "@/js/utils/util.js";
import {layerServiceURL} from "@/utils/mapUtil/layerServiceURL";
import {handleZoomForBoundary} from "@/utils/mapUtil/leafletFun";
import {wgs84togcj02, gcj02towgs84} from "coordtransform";

export default {
  data() {
    return {
      count: 0,
      mapId: "resource-assets-service-map",
      map: null,
      isMapInit: false,
      lon: window.global.view.center[0],
      lat: window.global.view.center[1],
      zoom: window.global.view.zoom,
      userEqui: sessionStorage.getItem("equiType"),
      equiWidth: sessionStorage.getItem("equiWidth"), //设备宽度 参数为用户当前设备的实际宽度（单位：px）
      icon: require("@/assets/resourceHall-Icon/耕地.png"), //标记点使用的图标
      timeoutIds: [],

    };
  },
  props: ["cqlxbh", "curTab"],
  computed: {
    ...mapGetters(["topSelectAreacode", "topSelectAreaname"]),
  },
  //监听地区的变化设为中心点
  watch: {
    async topSelectAreaname() {
      await clearMarkers(this.map.markersLayer);
      await this.loadAllMarkers();
      await fitView(this.map);
    },
  },

  mounted() {
    this.init();

    // 监听地图缩放事件, 触发加载对应层级的行政区划边界
    this.map.on("zoomend", this.handleZoomEnd);
    this.$bus.$on("resource-assets-map-center-change", ({id}) => {
      this.setCenterByMarkerId(id);
    });
    this.$bus.$on("resource-assets-update-map-markers", async (centerPoint) => {
      // console.log("--------刷新地图--------");
      this.stopAllTimeouts();
      await closeMarkersPopup(this.map.markersLayer);
      await clearMarkers(this.map.markersLayer);
      await this.loadAllMarkers();
      if (centerPoint) {
        this.setCenterByCenterPoint(centerPoint, this.map);
      } else {
        fitView(this.map);
      }
    });
  },

  beforeDestroy() {
    // 移除事件监听
    this.$bus.$off("resource-assets-map-center-change");
    this.$bus.$off("resource-assets-update-map-markers");
    this.stopAllTimeouts();
    clearMarkers(this.map.markersLayer);
  },

  methods: {
    /**
     * 初始化
     */
    async init() {
      this.map = initMap(this.mapId, {
        center: [this.lat, this.lon],
        zoom: this.zoom,
      });
      await this.loadAllMarkers();
      await fitView(this.map);
      this.$bus.$emit("resource-assets-map-initialized");
    },

    async getGeoJsonData(filterValue) {
      const typeName = layerServiceURL.china_mask.layerName; // 替换为您的 GeoServer 图层名称
      const filter = encodeURIComponent(`county='${filterValue}'`);

      const wfsUrl = `${layerServiceURL.china_mask_json.url}service=WFS&version=2.0.0&request=GetFeature&typeNames=${typeName}&outputFormat=application/json&CQL_FILTER=${filter}`;

      try {
        const response = await fetch(wfsUrl);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const geoJsonData = await response.json();
        return geoJsonData;
      } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
      }
    },


    /**
     * 添加所有markers
     */
    async loadAllMarkers() {
      this.stopAllTimeouts();
      // getBiddingXmxxByPgRedis getBiddingXmxxByPg
      const firstPage = await getBiddingXmxxByPgRedis({
        // current: 1,
        // size: MARKER_BATCH_SIZE,
        xzqbh: this.topSelectAreacode,
        cqlx: this.cqlxbh,
      });
      // console.log("----firstPage", this.topSelectAreacode, this.topSelectAreaname, this.cqlxbh, this.curTab);
      console.log("----firstPage", firstPage.data);
      if (firstPage?.data?.length) {
        this.addOrderMarkers(firstPage.data);
        let arr=await loadLandPolygons(firstPage.data,this.map.markersLayer)
        addPgAssetPolygons(this.map.markersLayer,arr,OrderInfoWindow,this.curTab)
        console.log("----firstPage", firstPage.data);
      } else {
        const geoJsonData = await this.getGeoJsonData(this.topSelectAreaname);
        if (geoJsonData) {
          const bounds = this.calculateGeoJsonBounds(geoJsonData);
          if (bounds && bounds.isValid()) {
            this.map.fitBounds(bounds, {
              padding: [50, 50],
              maxZoom: 15
            });
          }
        }
        console.log("----geoJsonData", geoJsonData);
        // 调用geoserver地图json服务，根据过滤条件： county='${filter}', 获取json数据
      }

      // const sumCount = firstPage.data.total;
      // const totalPage = Math.ceil(sumCount / MARKER_BATCH_SIZE);
      // // 使用setTimeout异步加载剩余页数据
      // for (let i = 2; i <= totalPage; i++) {
      //   const timeoutId = setTimeout(async () => {
      //     const pageData = await getBiddingXmxxByPg({
      //       current: i,
      //       size: MARKER_BATCH_SIZE,
      //       xzqbh: this.topSelectAreacode,
      //       cqlx: this.cqlxbh,
      //     });
      //     if (pageData?.data?.records?.length) {
      //       this.addOrderMarkers(pageData.data.records);
      //     }
      //     // 执行完成后从数组中移除（可选）
      //     this.timeoutIds = this.timeoutIds.filter((id) => id !== timeoutId);
      //   }, (i - 1) * 1500);
      //   this.timeoutIds.push(timeoutId);
      // }
    },

    calculateGeoJsonBounds(geoJsonData) {
      const bounds = L.latLngBounds();

      if (!geoJsonData || !geoJsonData.features || geoJsonData.features.length === 0) {
        return null;
      }

      geoJsonData.features.forEach(feature => {
        const geometry = feature.geometry;

        let coords = [];
        if (geometry.type === 'Polygon') {
          coords = geometry.coordinates[0];
        } else if (geometry.type === 'MultiPolygon') {
          geometry.coordinates.forEach(polygon => {
            coords = coords.concat(polygon[0]);
          });
        } else if (geometry.type === 'Point') {
          coords = [[geometry.coordinates[1], geometry.coordinates[0]]];
        }

        coords.forEach(coord => {
          bounds.extend(L.latLng(coord[1], coord[0]));
        });
      });

      return bounds;
    },


    /**
     *
     * @param dataList 绘制地区宗数地块标点（具体信息）
     */
    addOrderMarkers(dataList) {
      if (!dataList) return;
      const coordMap = new Map();
      for (const ele of dataList) {
        if (!ele.centerPoint) {
          if (ele.longitude && ele.latitude) {
            ele.centerPoint = ele.longitude + "," + ele.latitude;
          } else {
            // console.log("-------没有空间信息的marker,跳过-----------", ele);
            continue;
          }
        }

        const point = ele.centerPoint.split(",");
        //处理偏移量
        const key = `${point[0]},${point[1]}`;
        const count = coordMap.get(key) || 0;
        coordMap.set(key, count + 1);
        // 计算偏移后的点坐标
        let location = offsetLocation(count, point[0], point[1]);

        var customIcon = L.icon({
          iconUrl: this.icon, // 图标图像路径
          iconSize: [25, 35], // 图标大小 [宽度, 高度] (像素)
        });
        //添加marker到临时图层
        const [wgs84lng, wgs84lat] = gcj02towgs84(location.lng, location.lat);
        let marker = L.marker([wgs84lat, wgs84lng], {
          icon: customIcon,
        }).addTo(this.map.markersLayer);
        marker.properties = ele;

        //设置popup弹出框及信息
        let popup = L.popup().setContent("加载中...");
        marker.bindPopup(popup);

        let ComponentClass = Vue.extend(OrderInfoWindow);
        const instance = new ComponentClass({
          router,
          propsData: {
            info: ele,
            curTab: this.curTab,
          },
        });
        const content = instance.$mount().$el;

        marker.on("popupopen", async () => {
          // 返回一个 Promise，Leaflet 会自动处理异步内容
          try {
            //模拟后端api异步调用
            setTimeout(() => {
              popup.setContent(content);
              // popup.setContent(this.generatePopupContent(ele));
            }, 200);
          } catch (error) {
            return `加载失败: ${error.message}`;
          }
        });
      }
    },

    /**
     * 地块定位方法
     */
    setCenterByMarkerId(id) {
      console.log("---------收到id:xmbh,定位---------", id, this.map);
      let foundMarker = null;
      this.map.markersLayer.eachLayer((markerOrPolygon) => {
        let xmbh = markerOrPolygon.properties.xmbh;
        if (markerOrPolygon.properties && xmbh === id) {
          foundMarker = markerOrPolygon;
        }
      });
      zoomPopupMarker(foundMarker, this.map);
    },

    /**
     *根据centerPoint定位
     */
    setCenterByCenterPoint(centerPoint, map) {
      if (!centerPoint) return;
      const [lon, lat] = centerPoint.split(",");
      const latlng = L.latLng(lat, lon);
      map.flyTo(latlng, 17, {
        duration: 1, //速度1秒
      });
    },

    /**
     * 停止所有计时器
     */
    async stopAllTimeouts() {
      this.timeoutIds.forEach((id) => clearTimeout(id));
      this.timeoutIds = [];
    },

    /**
     * 根据缩放层级加载对应的行政区划边界，并清除其他层级的边界
     */
    handleZoomEnd() {
      const zoomRanges = [
        {
          layerType: "service",
          range: [5, 7],
          ...layerServiceURL["china_province"],
        },
        {
          layerType: "service",
          range: [7, 9],
          ...layerServiceURL["china_city"],
        },
        {
          layerType: "service",
          range: [9, 12],
          ...layerServiceURL["china_county"],
        },
        {
          layerType: "service",
          range: [12, 20],
          ...layerServiceURL["china_township"],
        },
      ];
      handleZoomForBoundary(this.map, this, zoomRanges);
    },
  },
};
</script>

<style lang="less" scoped>
.MapBox {
  width: 100%;
  height: 100%;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
</style>
